import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { buildGoogleFontsCdnUrl, buildCustomFontsCss } from 'dragonmouse-shared/ds';
import { VITE_FORGE_URL } from '@constants';

const GOOGLE_LINK_ID = 'ds-typography-google-fonts';
const CUSTOM_STYLE_ID = 'ds-typography-custom-fonts';

// Injects design system font files (Google + custom) into the document head
// so that typography specimens can render in the actual DS typefaces.
const FontLoader = () => {
	const fonts = useSelector((r: RootReducer) => r.mode.designSystemContent?.config?.fonts);

	useEffect(() => {
		if (!fonts || fonts.length === 0) return;

		// Google Fonts
		const googleUrl = buildGoogleFontsCdnUrl(fonts);
		let googleLink = document.getElementById(GOOGLE_LINK_ID) as HTMLLinkElement | null;
		if (googleUrl) {
			if (!googleLink) {
				googleLink = document.createElement('link');
				googleLink.id = GOOGLE_LINK_ID;
				googleLink.rel = 'stylesheet';
				document.head.appendChild(googleLink);
			}
			googleLink.href = googleUrl;
		} else if (googleLink) {
			googleLink.remove();
		}

		// Custom fonts (@font-face)
		const customCss = buildCustomFontsCss(fonts, `${VITE_FORGE_URL}/attachment`);
		let customStyle = document.getElementById(CUSTOM_STYLE_ID) as HTMLStyleElement | null;
		if (customCss) {
			if (!customStyle) {
				customStyle = document.createElement('style');
				customStyle.id = CUSTOM_STYLE_ID;
				document.head.appendChild(customStyle);
			}
			customStyle.textContent = customCss;
		} else if (customStyle) {
			customStyle.remove();
		}

		return () => {
			document.getElementById(GOOGLE_LINK_ID)?.remove();
			document.getElementById(CUSTOM_STYLE_ID)?.remove();
		};
	}, [fonts]);

	return null;
};

export default FontLoader;
